















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { ISettingsItem, IUserInfo } from '@app/componentlib/common/types/JobSearchTypes'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import Typeahead from '@app/componentlib/src/views/components/Typeahead.vue'
import MapView from '@app/componentlib/src/views/components/location-components/MapView.vue'
import RadiusSlider from '@app/componentlib/src/views/components/location-components/RadiusSlider.vue'
import { LocationModule } from '@app/componentlib/src/store/modules/locationdata'
import { boldSearchTerm } from '@app/componentlib/src/application/helpers/globalHelpers'
import { IRegion, IMapInformation, ILocationItem, ICountry } from '@app/componentlib/common/types/LocationTypes'
import MinimalisticDropdown from '@app/componentlib/src/views/components/MinimalisticDropdown.vue'

@Component<LocationComponentsContainer>({
  components: {
    Typeahead,
    MapView,
    RadiusSlider,
    MinimalisticDropdown
  },
  props: {
    userInfo: Object,
    useAllCountries: Boolean,
    useIcon: Boolean,
    locationToInit: Object,
    countryToInit: String,
    countriesToExclude: Array,
    canSearchFromMap: Boolean,
    settings: Object
  }
})

export default class LocationComponentsContainer extends Vue {
  /**
   * Props variables
   */
  userInfo: IUserInfo | undefined
  useAllCountries: boolean | undefined
  useIcon: boolean | undefined
  locationToInit: IRegion | undefined
  countryToInit: string | undefined
  countriesToExclude: string[] = []
  canSearchFromMap: boolean = false
  settings: ISettingsItem | undefined

  /**
   * Component state variables
   */
  locationInput: string = ''
  radiusDropdown = [10, 25, 50, 75, 100, 150, 200, 300]
  tempRegion: IRegion[] = []
  locationTypeahead: ILocationItem[] = []
  locationTypeaheadIsActive: boolean = false
  mapIsActive: boolean = false
  componentFinished: boolean = false

  /**
   * Lifecycle
   */
  async mounted() {
    await LocationModule.initCountryAndMap(this.countriesToExclude)
    await this.setDefaultCountry()
    const countryString = this.countryToInit !== '' ? this.countryToInit : this.userInfo?.countryCode
    await LocationModule.init(countryString || 'dk')
    LocationModule.getOtherLocationTypeaheads(countryString || 'dk')

    // This is to initiate the translations for countries
    this.countriesToShow

    if (
      this.locationToInit !== undefined &&
      this.locationToInit?.postal !== '' &&
      this.locationToInit?.radius !== 0
    )
      await this.initLocation()

    this.componentFinished = true
  }

  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  get mapInformation (): IMapInformation {
    return LocationModule.mapInformation
  }

  get mapInformations (): IMapInformation[] {
    return LocationModule.mapInformations
  }

  get locations (): IRegion[] {
    return LocationModule.locations
  }

  get countries (): ICountry[] {
    return LocationModule.countries
  }

  get countriesToShow (): ICountry[] {
    let tempArray = {...this.countries} as ICountry[]
    for (let item in tempArray) {
      tempArray[item].name = this.countryTrans(tempArray[item].countryCode)
    }

    return tempArray
  }

  get selectedCountry (): ICountry {
    return LocationModule.selectedCountry
  }

  get typeahead (): ILocationItem[] {
    return LocationModule.locationTypeahead
  }

  get isMobile (): boolean {
    return AppModule.isMobile
  }

  /**
   * Methods
   */
  startSearch(isFromMap: boolean) {
    if (isFromMap === false) {
      if (this.locationInput.length > 1) {
        this.locationSearchMethod()
        if (this.locationTypeahead.length > 0) {
          this.emitTypeaheadItem(this.locationTypeahead[0])
        }
      }
    }

    this.$emit('startSearch')
    this.locationInput = ''
  }

  countryTrans(country: string) {
    if (country.toLocaleLowerCase() === 'dk')
      return this.t.general_Country_Name_DK
    else if (country.toLocaleLowerCase() === 'se')
      return this.t.general_Country_Name_SE
    else if (country.toLocaleLowerCase() === 'no')
      return this.t.general_Country_Name_NO
    else (country.toLocaleLowerCase() === 'fi')
      return this.t.general_Country_Name_FI
  }

  setDefaultCountry () {
    const { setSelectedCountry, setMapInformation } = LocationModule

    // Be sure that user is not undefined and its countryCode is not empty
    if (this.countryToInit || (this.userInfo !== undefined && this.userInfo.countryCode !== '')) {
      // check if the country exists in the array
      let countryString = (this.countryToInit !== undefined && this.countryToInit !== '') ? this.countryToInit : this.userInfo?.countryCode.toLocaleLowerCase()
      let country = this.countries.find(c => c.countryCode.toLocaleLowerCase() === countryString?.toLocaleLowerCase())

      // If country exists, set it as the selected country
      if (country !== undefined && (this.countriesToExclude === undefined || !this.countriesToExclude.includes(country.countryCode))) {
        setSelectedCountry(country)
        // when country is set get mapinfo for that country
        let mapInfo = this.mapInformations.find(map => map.Country.toLocaleLowerCase() === country?.countryCode.toLocaleLowerCase())
        // if mapinfo is found set it at current mapinfo
        if (mapInfo !== undefined)
          setMapInformation(mapInfo)
      // else set default country and mapInfo
      } else {
        setSelectedCountry(this.countries[0])
        setMapInformation(this.mapInformations[0])
      }
    // else set default country and mapInfo
    } else {
      setSelectedCountry(this.countries[0])
      setMapInformation(this.mapInformations[0])
    }
  }

  openKeywordsTypeahead() {
    this.$emit('openKeywordsTypeahead', false)
  }

  locationSearchMethod() {
    // If location input is larger than one, start searching for relevant locations
    if (this.locationInput.length > 1) {
      // Get locations from locationstore based on postal or city
      this.locationTypeahead = this.typeahead.filter(item => item.postal.includes(this.locationInput) || item.city.toLowerCase().includes(this.locationInput.toLowerCase()))

      // Generate a displayText with the written part as bold, for each item stored in location typeahead
      this.locationTypeahead.forEach((item: ILocationItem) => item.displayTextModified = boldSearchTerm(item.displayText, this.locationInput))

      // Open op the location typeahead(which will show a list of locations based on input)
      this.openLocationTypeahead(true)
    }
    else {
      // If input is 1 or less close down the typeahead
      this.openLocationTypeahead(false)
    }
  }

  radiusDropdownClicked(radius: number) {
    const { setMapInformationRadius, setLocation } = LocationModule

    // Set the selected radius on map information
    setMapInformationRadius(radius)

    // Check if a location already exists, if yes update its radius
    let loc = this.locations
    if (loc[0] !== undefined && loc[0].radius !== undefined) {
      loc[0].radius = radius
      setLocation(loc)
    }
    this.radiusValueChanged(radius)
    this.$emit('emitParams')
  }

  changeMapIsActive() {
    this.mapIsActive = !this.mapIsActive

    if (this.mapIsActive) {
      this.changeShowOverlay(true)
    } else {
      this.changeShowOverlay(false)
    }
  }

  inputChanged() {
    this.$emit('inputChanged', this.locationInput)
  }

  removeLocation() {
    LocationModule.setLocation([])
    this.$emit('removeLocation')
  }

  startSearchFromMap() {
    this.changeShowOverlay(false)
    this.startSearch(true)
  }

  radiusValueChanged(radius: number) {
    const { setMapInformationRadius, setLocation } = LocationModule

    setMapInformationRadius(radius)
    this.tempRegion = this.locations

    if (this.tempRegion.length > 0) {
      this.tempRegion[0].radius = this.mapInformation.Radius
      this.tempRegion[0].mapViewText = this.tempRegion[0].postal + " " + this.tempRegion[0].city + " - Radius: " + this.tempRegion[0].radius + " km"

      setLocation(this.tempRegion)
    }
  }

  onTypeaheadSearch() {
    this.startSearch(false)
    this.locationTypeaheadIsActive = false
    this.changeShowOverlay(false)
  }

  openLocationTypeahead(bool: boolean) {
    this.locationTypeaheadIsActive = bool
    if (bool && this.locationTypeahead.length > 0)
      this.changeShowOverlay(true)
    else
      this.changeShowOverlay(false)
  }

  // Emit clicked item in from the typeahead
  emitTypeaheadItem(item: ILocationItem | undefined) {
    if (item !== undefined) {
      let postal = this.selectedCountry.countryCode === "SE" ? (item.postal.slice(0,3) + " " + item.postal.slice(3,10)) : item.postal
      this.tempRegion = [{
        type: "",
        postal: postal,
        city: item.city,
        mapViewText: (item.displayText.replace('$', '') + " - Radius: " + this.mapInformation.Radius + " km"),
        radius: this.mapInformation.Radius,
        lat: item.lat,
        lon: item.lon
      }]
      let tempMap = this.mapInformation
      tempMap.Lat = item.lat
      tempMap.Lng = item.lon
      tempMap.ZipCode = item.postal
      LocationModule.setMapInformation(tempMap)
    }

    else if (this.tempRegion[0])
      this.tempRegion[0].radius = this.mapInformation.Radius

    if (this.isMobile)
      this.locationTypeaheadIsActive = false

    LocationModule.setLocation(this.tempRegion)
    this.locationInput = ""
    this.changeShowOverlay(false)
    if (this.isMobile)
      this.$emit('emitParams')
  }

  changeShowOverlay(bool: boolean) {
    this.$emit('changeShowOverlay', bool)
  }

  countrySelected(item: ICountry) {
    // Check if country is not equal to current country, if not empty location, because postalcode is no longer equal to previous location
    if (item.countryCode !== this.selectedCountry.countryCode)
      LocationModule.setLocation([])

    let mapInfo = LocationModule.mapInformations.find(map => map.Country.toLocaleLowerCase() === item.countryCode.toLocaleLowerCase())
    if (mapInfo !== undefined)
      LocationModule.setMapInformation(mapInfo)

    LocationModule.setSelectedCountry(item)
    this.$emit('countrySelected')
  }

  async initLocation() {
    const tempLocation = []

    const { postal, radius, city, lat, lon } = this.locationToInit!

    if (this.locationToInit !== undefined && postal !== '') {
      this.locationToInit.mapViewText = (postal + " " + city + " - Radius: " + radius + " km")
      tempLocation.push(this.locationToInit)
    }

    let tempMapInfo = this.mapInformation
    tempMapInfo.Lat = lat || 1
    tempMapInfo.Lng = lon || 1
    tempMapInfo.Radius = radius

    LocationModule.setMapInformation(tempMapInfo)
    LocationModule.setLocation(tempLocation)
  }
}
